
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report_analytics/search",
      function () {
        return require("private-next-pages/report_analytics/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report_analytics/search"])
      });
    }
  